<template>
  <!-- 角色管理 -->
  <div class="dashboard-container">
    <div class="app-container">
      <el-card shadow="never">
        <el-form :inline="true" class="demo-form-inline">
          <div class="cg">
            <el-form-item label="角色名称：">
              <el-input v-model="listQuery.roleName" style="width: 200px" placeholder="请输入角色名称"
                        clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addRoleBtn" size="small" class="btns" icon="el-icon-plus">添加角色</el-button>
            </el-form-item>
          </div>
        </el-form>
        <el-table
          :header-cell-style="{ height: '40px' ,fontSize:'18px',color:'black',fontweight:400,background: '#fafafa'}"
          :header-row-style="{text: 'center'}"
          v-loading="listLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          :data="tableData"
          border style="width: 100%;margin-top: 50px;"
          :highlight-current-row="true">
          <el-table-column
            prop="poName"
            label="角色名称"
            align="center"
            width="180">
          </el-table-column>
          <el-table-column
            prop="poRemarks"
            header-align="center"
            align="left"
            label="备注">
          </el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="updateTime"
            align="center"
            label="修改时间">
          </el-table-column>
          <el-table-column label="操作" width="180px" header-align="center">
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-edit" @click="editAuth(scope.row.poId)">权限编辑</el-button>
                <el-button type="text" :disabled="isRole" icon="el-icon-delete" @click="editAuths(scope.row.poId)">删除</el-button>
<!--                <el-button type="text" icon="el-icon-delete">删除</el-button>-->
              </template>
          </el-table-column>
        </el-table>
        <role-auth-update ref="roleAuthUpdate"></role-auth-update>
      </el-card>

      <el-dialog
        title="角色添加"
        :visible.sync="addRoleShow"
        width="30%">
        <el-form :model="roleFrom" status-icon :rules="rules" ref="roleFrom" label-width="100px" class="demo-roleFrom">
          <el-form-item label="角色名称" prop="poName">
            <el-input  v-model="roleFrom.poName"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="poRemarks">
            <el-input v-model="roleFrom.poRemarks"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addRoleShow = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('roleFrom')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import RoleAuthUpdate from "./RoleAuthUpdate.vue";
import apiBaseUrl from "../../../config/api";
import { addPost } from "@/api/salaryapi"
export default {
  components: {RoleAuthUpdate},
  data() {
    return {
      listQuery: {
        roleName: '',
      },
      listLoading: false, //加载样式
      tableData: [],
      addRoleShow:false,
      roleFrom:{
        poName:'',
        poRemarks:"",
      },
      rules:{
        poName: [
            { required: true, message: '请输入角色名称', trigger: 'blur' },
            { min: 1, max: 20, message: '长度在 1 到 20个字符', trigger: 'blur' }
          ],
      },

      isRole: true,
    }
  },
  created() {
    this.listData()
  },
  mounted() {

    this.isRole = window.sessionStorage.getItem('isRole') == 'true' ? true : false

  },
  methods: {
    submitForm(roleFrom){
      this.$refs[roleFrom].validate((valid) => {
        console.log(valid);
          if (valid) {
            addPost(this.roleFrom).then((res)=>{
              if (res.code == 200) {
                this.addRoleShow = false
                this.listData()
                this.$message.success("添加成功")
              }
            })
          } else {
            this.$message.error("请输入角色名称")
            return false;
          }
        });

    },
    addRoleBtn(){
      this.addRoleShow = true
    },

    editAuths(id){
      this.$confirm('确定要删除吗?, 是否继续?', '提示', {  confirmButtonText: '确定', cancelButtonText: '取消',  type: 'warning' }).then(() => {
          axios.post(`${apiBaseUrl}/admin/delPost/${id}`, {}, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
            if (res.data.code === 200) {
              this.$message({ message:res.data.message, type: "success" })
              this.listData()
            } else {
              this.$message.error(res.data.message)
            }
          }).catch((err) => {
            this.$message.error(err)
          })
      })
    },
    //分配权限
    editAuth(roleId) {
      this.$nextTick(() => {
        this.$refs.roleAuthUpdate.init(roleId)
      })
    },
    //查询所有权限
    listData() {
      const data = {
        po_id: '0',
        poName: this.listQuery.roleName
      }
      axios
        .post(
          `${apiBaseUrl}/admin/postlist`,
          data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
        )
        .then(response => {
          this.tableData = response.data.data.list;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSearch() {
      this.listData()
    }
  },
}

</script>
<style scoped>
.demo-form-inline {
  height: 35px;
  display: flex;
}

.cg {
  /* flex: 1; */
  margin-top: 20px;
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/RoleManagement.vue